import { useEffect, useState } from 'react'

import { isExpandEnabled } from '../helpers'

const useConceptToggle = ({ selected, editable, expandable }) => {
  const [expanded, setExpanded] = useState(false)
  const canExpand = isExpandEnabled({ selected, editable, expandable })

  useEffect(() => {
    if (!canExpand) setExpanded(false)
  }, [canExpand])

  const toggleExpanded = () => {
    setExpanded(current => !current)
  }

  return {
    expanded,
    canExpand,
    toggleExpanded,
  }
}

export default useConceptToggle
